// extracted by mini-css-extract-plugin
export default {"container":"entity_link_container_container__hJh9V"};